import { connect } from 'react-redux'
import Dashboard from '../components/Dashboard'

import { listLastLead, listTask } from '../../lead/LeadActions'
import { dataNewLead, dataNewProvider, dataNewTask, listAllDepartments } from '../../datas/DatasActions'


const mapStateToProps = (state) => {
    return {
        user : state.user,
        lead : state.lead,
        task : state.lead.task,
        datas : state.datas,
        departments : state.datas.all_departments,
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        listLastLead: (region) => {
        	return dispatch(listLastLead(region))
        },
        listTask: (region) => {
            return dispatch(listTask(region))
        },
        dataNewLead: (date, region) => {
        	return dispatch(dataNewLead(date, region))
        },
        dataNewProvider: (date, region) => {
            return dispatch(dataNewProvider(date, region))
        },
        dataNewTask: (date, region) => {
        	return dispatch(dataNewTask(date, region))
        },
        listAllDepartments:() =>{
            return dispatch(listAllDepartments())
        }
        
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)



// WEBPACK FOOTER //
// ./src/btob/containers/DashboardContainer.js